import React from 'react';

import Incentive from 'components/Tvendo/Commissions/Operations/Incentive/Incentive.js';

export default function () {
  return <Incentive />;
}
